<template>
    <v-container fluid class="pa-0">
        <HeaderBar :isMobile="isMobileDevice" />
        <!-- ページコンテンツ -->
        <v-main>
          <router-view></router-view>
        </v-main>
        <FooterNavi />
    </v-container>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import isMobile from "ismobilejs";
import HeaderBar from "./HeaderBar.vue";
import FooterNavi from "./FooterNavi.vue";

// モバイルかどうかを判定
const isMobileDevice = ref(isMobile.any);

onMounted(() => {
  // デバイスのタイプをログに出力
  if (isMobileDevice.value) {
    console.log("This is a mobile device.");
  } else {
    console.log("This is not a mobile device.");
  }
});
</script>
